"use client";

import dynamic from "next/dynamic";
import { CSPostHogProvider } from "./providers";

const LegacyProvider = dynamic(() => import("./providers").then((mod) => mod.CSPostHogProvider), { ssr: false });

// Client components still render their children on the server. Only analytics
// initialization belongs in an effect; it must not gate the application shell.
export default function PostHogProviderClient({
  children,
  bootstrapData,
  guestUpload = false,
}: {
  children: React.ReactNode;
  bootstrapData?: any;
  guestUpload?: boolean;
}) {
  if (!guestUpload) return <LegacyProvider bootstrapData={bootstrapData}>{children}</LegacyProvider>;
  return (
    <CSPostHogProvider bootstrapData={bootstrapData}>
      {children}
    </CSPostHogProvider>
  );
}
